<template>
  <div>
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="物料"><el-input v-model="query.materialCode" size="small" clearable style="width:140px" /></el-form-item>
      <el-form-item label="文档"><el-input v-model="query.documentCode" size="small" clearable style="width:140px" /></el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('plm:plmInspectionSpec:list')" type="primary" size="small" @click="search">查询</el-button>
        <el-button v-if="isAuth('plm:plmInspectionSpec:save')" type="primary" size="small" @click="open()">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="pageList" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
      <el-table-column prop="materialCode" label="物料编码" min-width="120" header-align="center" align="left">
        <template slot-scope="scope">
          <a v-if="isAuth('plm:plmInspectionSpec:info') || isAuth('plm:plmInspectionSpec:update')" class="code-link" @click="open(scope.row)">{{ scope.row.materialCode }}</a>
          <span v-else>{{ scope.row.materialCode }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="documentCode" label="规范文档" min-width="130" header-align="center" align="left" />
      <el-table-column prop="enabled" label="启用" width="70" header-align="center" align="center">
        <template slot-scope="scope">{{ scope.row.enabled === '1' ? '是' : '否' }}</template>
      </el-table-column>
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="total"
      layout="total, sizes, prev, pager, next, jumper" @size-change="s => { pageSize = s; pageIndex = 1 }" @current-change="p => { pageIndex = p }" />

    <el-dialog :title="form.id ? '修改检验规范关联' : '新增检验规范关联'" :visible.sync="visible" width="min(560px, calc(100vw - 24px))" :close-on-click-modal="false">
      <el-form ref="dataForm" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="物料" prop="materialId">
          <el-select v-model="form.materialId" filterable style="width:100%">
            <el-option v-for="item in materials" :key="item.materialId" :label="item.materialCode + ' / ' + item.materialName" :value="item.materialId" />
          </el-select>
        </el-form-item>
        <el-form-item label="规范文档" prop="documentId">
          <el-select v-model="form.documentId" filterable style="width:100%">
            <el-option v-for="item in documents" :key="item.documentId" :label="item.documentCode + ' / ' + item.documentName" :value="item.documentId" />
          </el-select>
        </el-form-item>
        <el-form-item label="启用">
          <el-select v-model="form.enabled" style="width:100%">
            <el-option label="是" value="1" /><el-option label="否" value="0" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button v-if="form.id && (isAuth('plm:plmInspectionSpec:delete') || isAuth('plm:plmInspectionSpec:save'))" type="danger" @click="remove">删除</el-button>
        <el-button v-if="form.id ? (isAuth('plm:plmInspectionSpec:update') || isAuth('plm:plmInspectionSpec:save')) : isAuth('plm:plmInspectionSpec:save')" type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'

export default {
  name: 'PlmInspectionSpec',
  data() {
    return {
      query: { materialCode: '', documentCode: '' },
      list: [], materials: [], documents: [], pageIndex: 1, pageSize: 10, loading: false, visible: false, permCodes: [], form: {},
      headStyle: { background: '#f5f7fa', color: '#606266', textAlign: 'center' },
      rules: {
        materialId: [{ required: true, message: '物料不能为空', trigger: 'change' }],
        documentId: [{ required: true, message: '文档不能为空', trigger: 'change' }]
      }
    }
  },
  computed: {
    filtered() {
      return this.list.filter(row => this.has(row.materialCode, this.query.materialCode) && this.has(row.documentCode, this.query.documentCode))
    },
    total() { return this.filtered.length },
    pageList() { return this.filtered.slice((this.pageIndex - 1) * this.pageSize, this.pageIndex * this.pageSize) }
  },
  created() { this.loadPerms(); this.load() },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    has(value, keyword) {
      const text = String(keyword || '').trim().toLowerCase()
      if (!text) return true
      return String(value || '').toLowerCase().indexOf(text) >= 0
    },
    search() { this.pageIndex = 1; this.load() },
    load() {
      this.loading = true
      request.get('/plm/spec/list').then(res => { this.list = res.data || [] }).catch(() => { this.list = [] }).finally(() => { this.loading = false })
    },
    open(row) {
      this.visible = true
      this.loadOptions()
      const blank = () => ({ id: '', materialId: '', documentId: '', enabled: '1', remark: '' })
      if (!row || !row.id) {
        this.form = blank()
        this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
        return
      }
      request.get('/plm/spec/info', { params: { id: row.id } }).then(res => {
        this.form = Object.assign(blank(), res.data || row)
        this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
      }).catch(() => {
        this.form = Object.assign(blank(), row)
        this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
      })
    },
    loadOptions() {
      request.post('/base/material/page', { currentPage: 1, pageSize: 500 }).then(res => { this.materials = (res.data && res.data.list) || [] }).catch(() => {})
      request.get('/plm/document/list').then(res => { this.documents = res.data || [] }).catch(() => {})
    },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        request.post('/plm/spec/save', {
          id: this.form.id, materialId: this.form.materialId, documentId: this.form.documentId, enabled: this.form.enabled, remark: this.form.remark
        }).then(() => { this.$message.success('保存成功'); this.visible = false; this.load() }).catch(() => {})
      })
    },
    remove() {
      if (!this.form.id) return
      this.$confirm('确定删除该检验规范关联?', '提示', { type: 'warning' }).then(() => {
        request.post('/plm/spec/delete', { id: this.form.id }).then(() => {
          this.$message.success('删除成功'); this.visible = false; this.load()
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.code-link { color: #348adb; cursor: pointer; }
</style>
